<template>
	<div class="orderpage">
		<div class="orderpage-btn">
			<el-button  size="mini" type="primary" v-print="'#printTest'">{{$t('other.a342')}}</el-button>
		</div>
		<div id="printTest">
			<div>
			    <div class="pick-list-wrpper">
					<div class="print-area" v-if="th_printdata.length">
					
						<div>
							<div v-for="(item,index) in th_printdata">
								<div class="desc-info">
									<div style="display: flex;border-bottom: 2px #000000 dashed;justify-content: space-between;box-sizing: border-box;padding: 10px;">
										<img style="width:150px" src="../assets/img/pic/id-01.png" />
										<img v-if="item.logistics.indexOf('JNE Reguler') > -1" style="width:150px" src="../assets/img/pic/jne.png" />
										<img v-if="item.logistics.indexOf('J&T') > -1" style="width:150px" src="../assets/img/pic/jt.png" />
										<img v-if="item.logistics.indexOf('Ninja') > -1" style="width:150px" src="../assets/img/pic/njnja.png" />
										<img v-if="item.logistics.indexOf('JNE JTR') > -1" style="width:150px" src="../assets/img/pic/jtr.png" />
										<img v-if="item.logistics.indexOf('ID') > -1" style="width:150px" src="../assets/img/pic/id.png" />
										<img v-if="item.logistics.indexOf('Halu') > -1" style="width:150px" src="../assets/img/pic/halu.png" />
										<img v-if="item.logistics.indexOf('REG') > -1" style="width:150px" src="../assets/img/pic/reg.png" />
										<img v-if="item.logistics.indexOf('Sameday') > -1" style="width:150px" src="../assets/img/pic/sameday.png" />
										<img v-if="item.logistics.indexOf('Shopee Express Standard') > -1" style="width:150px" src="../assets/img/pic/shopex.png" />
									</div>
									<div class="orderpage-poo-box">
										<div style="display: flex;">
											<div class="orderpage-poo">No. Resi: {{item.trackingNo}}</div>
										</div>
										<!-- <img style="width: 600px;"  :src="item.trackingNoBarCode" /> -->
									</div>
								
									<div class="receipt-item-box">
										<div class="receipt-item">
											<span style="font-size:18px;font-weight:bold">Penerima：{{item.buyerName}}</span>
											<span style="font-size:18px;font-weight:bold">Pengirim：{{item.shopId}}</span>
										</div>
										<div class="receipt-item">
											<span style="font-size:18px;">{{item.buyerPhone}}</span>
											<span style="font-size:18px;">6281219982737</span>
										</div>
										<div class="receipt-item">
											<span class="area">{{item.buyerName}}</span>
										    <span style="font-size: 18px;">000</span>
										</div>
									</div>
							
									<div style="border-bottom: 2px solid #000000;border-top: 2px solid #000000;">
										<div style="display: flex;justify-content: center;">
											<span class="city-tap01">{{item.buyerName}}</span>
											<span class="city-tap01">{{item.buyerName}}</span>
										</div>
										<div style="display: flex;justify-content: center;">
											<span class="city-tap">CASHLESS</span>
											<span class="city-tap">Penjual tidak perlu bayar ongkir ke Kurir</span>
										</div>
									</div>
								
									<div class="desc-info-footer">
										<div class="desc-info-footer-left">
											<div>
												<span class="desc-info-left-text">Berat：{{item.buyerName}} gr</span>
												<span class="desc-info-left-text">COD：RP{{item.buyerName}}</span>
											</div>
											<div>
												<span class="desc-info-left-text">Batas Kirim：{{item.buyerName}}</span>
											</div>
											<div>
												<span class="desc-info-left-text">No.Pesanan： {{item.buyerName}}</span>
											</div>
										</div>
									<!-- 	<div class="desc-info-footer-right"> 
											<img style="width: 377px;height: 70px;"  :src="item.orderIdBarCode" />
										</div> -->
									</div>
								</div>
								<div style="display: flex;
								justify-content: space-between;
								font-size: 18px;
								font-weight: bold;
								box-sizing: border-box;
								padding: 0 10px;
								border-bottom: 1px #000000 solid;">
									<span class="tto01">#</span>
									<span class="tto">Nama Produk</span>
									<span class="tto">SKU</span>
									<span class="tto">Variasi</span>
									<span class="tto">cusCode</span>
									<span>Qty</span>
								</div>
								<div class="cco" v-for="(p,index) in item.items">
									<span class="tto01">{{index + 1}}</span>
									<span class="tto">{{p.itemName}}</span>
									<span class="tto">{{p.variationSku}}-({{p.storeItem ? p.storeItem.skuName : '--'}})</span>
									<span class="tto">{{p.variationName}}</span>
									<span class="tto">{{p.storeItem ? p.storeItem.cusCode : '--'}}</span>
									<span>{{p.variationQuantityPurchased}}</span>
								</div>
								<span style="display: inline-block;font-size: 18px;padding-top: 15px;">Pesan：({{item.ordersn}})</span>
								
								<div style="page-break-after:always"></div>
							</div>
						</div>
					</div>
					
				</div>
			
			</div>
		</div>
		
	</div>
	
</template>
<script>
import utils from '../utils/utils'
	import {
		mapState,
	     mapActions,
	} from 'vuex'
	import loading from './loading.vue'
	import Papa from 'papaparse'
	import json2csv from 'json2csv'
	import csvExportor from "csv-export";
	export default {
	    data() {
	      return {
	        th_printdata:[],
		  }
	    },
		components:{
			loading
		},
		computed:{
			...mapState({
				picklist: state => state.order.picklist,
				seller: state => state.login.userInfo.userId
			}),
		
			
		},
		created(){
			// this.ttp()
			this.init()
		},
	
		methods:{
			...mapActions('order', [
				'getUnprocessOrder',//获取所有商店待处理订单
				'auditOrder',
				'getPrintOrder', //打印订单
				'getOrdersBytrickNo'
				
			]),
			//从storage上拿下将要打印的item
			init(){
				this.th_printdata=JSON.parse(localStorage.getItem('printcontent'))
				console.log(this.th_printdata)
				
			},
			
			
			// getTiem(time) {
			// 	let ttp = time.slice(0, time.indexOf('T'))
			// 	let ccp = time.slice(time.indexOf('T') + 1, time.indexOf('.'))
			// 	return ttp 
			// },
		}
	  }
</script>

<style>
	.orderpage{
		width: 100%;
		background: #fff;
		z-index: 99999;
		/* display: flex;
		flex-direction: column;
		justify-content: center; */
	
	}
	.orderpage .pick-list-wrpper{
		width: 100%;
		display: flex;
		justify-content: center;
		font-size: 12px;
	}
	
	.orderpage-btn{
		width: 800px;
		margin: 0 auto;
		display: flex;
		justify-content: flex-end;
		padding: 10px 0;
	}
	
	.orderpage .print-area{
		width: 800px;
		height: 100%;
		margin-bottom: 200px;
	}
	.desc-info{
		width: 798px;
		
		border: 2px #000000 solid;
	}
	
	.orderpage-poo-box{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-bottom: 5px;
		border-bottom: 2px #000000 dashed
	}
	
	.orderpage-poo{
		min-width: 265px;
		height: 40px;
		border: 2px solid #000000;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		margin: 5px 10px;
	}
	
	.receipt-item{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding:5px 10px;
	}
	
	.receipt-item .area {
		display: inline-block;
		width: 50%;
		font-size: 18px;
	}
	
	.desc-info-left-text{
		font-size: 18px;
		font-weight: bold;
		padding-right: 30px;
	}
	
	.desc-info-footer{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 5px 10px;
	}
	
	.tto{
		display: inline-block;
		width: 200px;
		text-align: center;
		box-sizing: border-box;
		padding: 5px;
	}
	.tto01{
		display: inline-block;
		width: 100px;
	}
	.cco{
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		border-bottom: 1px #000000 solid;
		box-sizing: border-box;
		padding: 0 10px;
	}
	
	.city-tap{
		display: inline-block;
		padding: 5px;
		border: 2px solid #000000;
		margin: 5px 0;
		padding: 5px 15px;
		font-size: 18px;
	}
	
	.city-tap01{
		display: inline-block;
		padding: 5px;
		border: 2px solid #000000;
		margin: 5px 5px;
		font-size: 18px;
		padding: 5px 15px;
	}
	
	
	
	
	
	
</style>
